export default __webpack_public_path__ + "static/media/Amarillo.6e728a5f.woff2";